import { motion } from "framer-motion";

const SERVICES = [
  {
    number: "01",
    title: "Private Estate Placement",
    copy: "Full-time, discreet culinary residency within your household. Menus composed around your family's rhythms — from quiet weekday breakfasts to formal weekend entertaining.",
  },
  {
    number: "02",
    title: "High-Profile Event Catering",
    copy: "Intimate dinners and private gatherings executed with silent precision. Every course choreographed, every detail invisible — until the first plate arrives.",
  },
  {
    number: "03",
    title: "Tailored Nutritional Curation",
    copy: "Bespoke programs designed alongside your physicians and trainers. Performance nutrition, elevated to the standard of fine dining — never the reverse.",
  },
];

export default function Experience() {
  return (
    <section
      data-testid="experience-section"
      className="px-6 sm:px-12 lg:px-20 py-24 md:py-32 lg:py-40 border-b border-white/10"
    >
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1 }}
        className="text-[11px] uppercase tracking-[0.4em] text-[#EAE6DF]/70 mb-6"
      >
        The Experience
      </motion.p>
      <motion.h2
        data-testid="experience-heading"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white max-w-2xl mb-20 md:mb-28"
      >
        Three ways of working, one standard of excellence.
      </motion.h2>

      <div>
        {SERVICES.map((service, i) => (
          <motion.div
            key={service.number}
            data-testid={`service-item-${i + 1}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="group grid grid-cols-12 gap-6 md:gap-10 border-t border-white/10 py-12 md:py-16 last:border-b"
          >
            <span className="col-span-12 md:col-span-2 text-xs tracking-[0.3em] text-[#EAE6DF]/60 pt-2">
              {service.number}
            </span>
            <h3 className="col-span-12 md:col-span-4 font-serif font-light text-2xl sm:text-3xl text-white transition-opacity duration-300 group-hover:opacity-70">
              {service.title}
            </h3>
            <p className="col-span-12 md:col-span-6 text-sm sm:text-base font-light leading-relaxed text-[#F5F5F7]/60 max-w-xl">
              {service.copy}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
